<div class="ds-grid mx-auto ds-body">
  <div class="row">
    <div class="col-12 d-md-none pt-7">
      <ng-container *ngTemplateOutlet="indexList"></ng-container>
    </div>
    <div class="d-none d-md-block">
      <div class="col-3">
        <div class="position-relative">
          <div class="position-absolute index-position pt-7">
            <ng-container *ngTemplateOutlet="indexList"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #indexList>
  <ul class="mb-6 px-1 cms-ds-list">
    <li (click)="scrollIntoView(h)"
        *ngFor="let h of this.headlines"
        [class.ms-4]="hasClass(h, 'lvl-2')"
        class="btn-link mb-3 ds-cursor--pointer"
        tabindex="0">
      {{h.innerText}}
    </li>
  </ul>
</ng-template>
